export enum EventoClassificacaoDePaginasPZ {
  MODIFICACAO_DE_IDENTIFICACAO_DE_PAGINA = 'MODIFICACAO_DE_IDENTIFICACAO_DE_PAGINA',
  SINCRONIZACAO_DE_IDENTIFICACAO_DE_PAGINAS = 'SINCRONIZACAO_DE_IDENTIFICACAO_DE_PAGINAS',
}
